import { createAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from './ENUM__redux_action';

export const LOCAL__global_reset = createAction(ENUM__redux_action.GLOBAL_RESET);
